// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.marriage-information-table {
  margin: 20px 0;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  margin-bottom: 20px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px 0;
  border-bottom: 1px solid #e9ecef;
}

.table-header h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.add-btn {
  background: #28a745;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

/* Responsive design */
@media (max-width: 768px) {
  .table-header {
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
  }
  
  .add-btn {
    width: 100%;
  }
  
  .radio-options {
    flex-direction: column;
    gap: 10px;
  }
  
  .marriage-table {
    font-size: 11px; /* Even smaller font for mobile */
    min-width: 800px; /* Reduced minimum width for mobile */
  }
  
  .marriage-table th,
  .marriage-table td {
    padding: 6px 3px; /* Further reduced padding */
  }
  
  .marriage-table input,
  .marriage-table select {
    padding: 4px 6px; /* Further reduced padding */
    font-size: 11px; /* Smaller font for mobile */
  }
  
  .marriage-table input[type="date"] {
    min-width: 90px; /* Smaller minimum width for mobile */
  }
  
  .marriage-table input[type="text"] {
    min-width: 80px; /* Smaller minimum width for mobile */
  }
  
  .serial-number {
    width: 30px; /* Smaller width for mobile */
  }
  
  .actions {
    width: 40px; /* Smaller width for mobile */
  }
} `, "",{"version":3,"sources":["webpack://./src/components/DynamicMarriageInformationTable.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe,EAAE,iCAAiC;IAClD,gBAAgB,EAAE,qCAAqC;EACzD;;EAEA;;IAEE,gBAAgB,EAAE,4BAA4B;EAChD;;EAEA;;IAEE,gBAAgB,EAAE,4BAA4B;IAC9C,eAAe,EAAE,4BAA4B;EAC/C;;EAEA;IACE,eAAe,EAAE,qCAAqC;EACxD;;EAEA;IACE,eAAe,EAAE,qCAAqC;EACxD;;EAEA;IACE,WAAW,EAAE,6BAA6B;EAC5C;;EAEA;IACE,WAAW,EAAE,6BAA6B;EAC5C;AACF","sourcesContent":[".marriage-information-table {\n  margin: 20px 0;\n  border: 1px solid #e1e5e9;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n\n.table-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n  padding: 10px 0;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.table-header h4 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n}\n\n.add-btn {\n  background: #28a745;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .table-header {\n    flex-direction: column;\n    gap: 10px;\n    align-items: stretch;\n  }\n  \n  .add-btn {\n    width: 100%;\n  }\n  \n  .radio-options {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .marriage-table {\n    font-size: 11px; /* Even smaller font for mobile */\n    min-width: 800px; /* Reduced minimum width for mobile */\n  }\n  \n  .marriage-table th,\n  .marriage-table td {\n    padding: 6px 3px; /* Further reduced padding */\n  }\n  \n  .marriage-table input,\n  .marriage-table select {\n    padding: 4px 6px; /* Further reduced padding */\n    font-size: 11px; /* Smaller font for mobile */\n  }\n  \n  .marriage-table input[type=\"date\"] {\n    min-width: 90px; /* Smaller minimum width for mobile */\n  }\n  \n  .marriage-table input[type=\"text\"] {\n    min-width: 80px; /* Smaller minimum width for mobile */\n  }\n  \n  .serial-number {\n    width: 30px; /* Smaller width for mobile */\n  }\n  \n  .actions {\n    width: 40px; /* Smaller width for mobile */\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
